import { useEffect } from 'react';

export const SEO = ({ title, description, image, url, type = 'website' }) => {
  useEffect(() => {
    // 1. Update Document Title
    const siteName = 'YooSpeak';
    const fullTitle = title ? `${title} | ${siteName}` : 'YooSpeak - Learn Languages & Join Live Classes';
    document.title = fullTitle;

    // Helper to update meta tag
    const setMetaTag = (selector, attribute, attributeValue, content) => {
      if (!content) return;
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, attributeValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // 2. Standard Meta Tags
    setMetaTag('meta[name="description"]', 'name', 'description', description || 'Browse interactive courses, live group classes, and vibrant community learning on YooSpeak.');
    
    // 3. Open Graph Tags
    setMetaTag('meta[property="og:title"]', 'property', 'og:title', fullTitle);
    setMetaTag('meta[property="og:description"]', 'property', 'og:description', description || 'Learn languages and connect with expert teachers on YooSpeak.');
    setMetaTag('meta[property="og:image"]', 'property', 'og:image', image || 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=1200&h=630&fit=crop');
    setMetaTag('meta[property="og:url"]', 'property', 'og:url', url || window.location.href);
    setMetaTag('meta[property="og:type"]', 'property', 'og:type', type);

    // 4. Twitter Card Tags
    setMetaTag('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
    setMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', fullTitle);
    setMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', description || 'Explore live classes and courses on YooSpeak.');
    setMetaTag('meta[name="twitter:image"]', 'name', 'twitter:image', image || 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=1200&h=630&fit=crop');
  }, [title, description, image, url, type]);

  return null;
};

export default SEO;
